<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px; padding-top: 20px;">
    <img style="width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="text-align: center;">Моята поръчка</h2>
    <div style="height: 76vh; overflow-y: scroll; margin-bottom: 5px;">

        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <p *ngIf="this.order?.contactUUID && this.order?.toAddress">Доставка до адрес</p>
            <p *ngIf="this.order?.carrierOfficeAddress && this.order?.toCarrierOffice">Доставка до офис на Speedy</p>

            <div *ngIf="this.order?.contactUUID && this.order?.toAddress" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-address.png" alt="">
                <p style="display: inline-block; width: 65%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.addressName }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.phone }} </span><br>
                    {{  this.getAddressString() }}
                </p>
            </div>
            <div *ngIf="this.order?.carrierOfficeAddress && this.order?.toCarrierOffice" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/delivery-courier.png" alt="">
                <p style="display: inline-block; width: 65%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficeName  }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficePhone }} </span><br>
                    {{ this.order?.carrierOfficeAddress }}
                </p>
            </div>
        </div>

        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <p>Данни за фактура</p>
            <div *ngIf="this.order?.isNewInvoiceAddress && this.order?.invoiceContactUUID" style="display: flex; align-items: center; margin-top: 5px;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-invoice-address.svg" alt="">
                <p style="display: inline-block; width: 65%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.invoiceAddressName }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.invoicePhone }} </span><br>
                    {{  this.getInvoiceAddressString() }}
                </p>
            </div>
            <div *ngIf="!this.order?.isNewInvoiceAddress && this.order?.contactUUID && this.order?.toAddress" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-address.png" alt="">
                <p style="display: inline-block; width: 65%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.addressName }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.phone }} </span><br>
                    {{  this.getAddressString() }}
                </p>
            </div>
            <div *ngIf="!this.order?.isNewInvoiceAddress && this.order?.carrierOfficeAddress && this.order?.toCarrierOffice" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/delivery-courier.png" alt="">
                <p style="display: inline-block; width: 65%; margin: 5px;">
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficeName  }} </span><br>
                    <span style="margin-bottom: 5px;"> {{  this.order?.carrierOfficePhone }} </span><br>
                    {{ this.order?.carrierOfficeAddress }}
                </p>
            </div>
        </div>

        <div style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <p>Плащане</p>
            <div *ngIf="this.order?.paymentCard && this.order?.cardPayment" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" [src]="this.cardImg(this.order!.paymentCard!)" alt="">
                <p class="col-6"  style="padding-left: 0px; font-weight: 500; display: inline-block; width: 50%; margin: 5px;">{{ this.getCardDetail(this.order!.paymentCard!)  }}</p>
            </div>
            <div *ngIf="!this.order?.cardPayment" style="display: flex; align-items: center;">
                <img style="width: 44px; height: 44px; margin: 5px;" src="/assets/images/shared/icon-cash-on-delivery.png" alt="">
                <p style="display: inline-block; width: 70%; margin: 5px;">Наложен платеж</p>
            </div>
        </div>


        <div *ngIf="this.isGroup && this.groupCartLine" style="width: 95%; margin: auto; margin-top: 20px; background-color: white; padding: 10px; border-radius: 10px">


            <div style="height: 145px; width: 100%;">
                <div style="height: 130px; margin: 0px;" class="row">
                    <!-- <div class="form-check col-1" style="display: inline-block; vertical-align: top; margin-top: 30px;">
                        <input [id]="productPerOrg.uuid" class="form-check-input" type="checkbox" value="" [checked]="this.cartLines[productPerOrg.uuid].selected" (change)="this.productToggle($event, productPerOrg.uuid)">
                    </div> -->
                    <label style="width: 100px; height: 110px; padding: 3px; border: 1px solid #EDF5FC; border-radius: 10px; margin-top: 10px; vertical-align: unset;" [for]="this.groupCartLine!.uuid">
                        <img style="width: 90px; height: 100px; vertical-align: unset;"   [src]="this.groupCartLine!.imageSource" alt="">
                    </label>
                    <div class="col-7 product"  style="display: inline-block;  margin-top: 10px; " >
                        <p (click)="this.goToProduct(this.groupCartLine)" style="font-size: 13px; font-weight: bold; margin-bottom: 5px; display: -webkit-box;-webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; height: 40px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-top: 5px; text-overflow: ellipsis;">{{ this.groupCartLine!.sku.product.name }}</p>
                        <p  *ngIf="this.groupCartLine!.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;"><span *ngFor="let option of this.groupCartLine!.sku?.options || []; index as i"> {{ option.option?.display_name + ': ' + this.returnOptionValue(option) + ((i != this.groupCartLine!.sku.options.length - 1) ? ' | ' : '')}}</span></p>
                        <p *ngIf="!this.groupCartLine!.sku.options.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>
                        <div style="min-width: 170px;">
                          <div class="preorder-item-row">
                            <div class="preorder-item-info">
                              <app-price
                                class="preorder-line-total-price"
                                [amount]="getLineTotalBase(this.groupCartLine)"
                                layout="inline"
                              ></app-price>

                              <div class="preorder-item-subprice">
                                <span class="preorder-line-mult">{{ pricingInfoText(this.groupCartLine) }}</span>
                                <app-price
                                  class="preorder-line-unit-price"
                                  [amount]="getUnitPriceBase(this.groupCartLine)"
                                  layout="inline"
                                ></app-price>
                              </div>
                            </div>

                            <div class="preorder-item-qty">
                              <span>Брой: {{ this.groupCartLine!.quantity }}</span>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
                <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 15px; margin-bottom: 10px;">

            </div>
        </div>

        <div>
            <div *ngFor="let orgs of this.allOrgs">
                <div *ngIf="this.cartLinePerOrganisation[orgs].length" style="width: 95%; margin: auto; margin-top: 20px; background-color: white; padding: 10px; border-radius: 10px">


                    <div style="height: 145px; width: 100%;"  *ngFor="let productPerOrg of this.cartLinePerOrganisation[orgs]">
                        <div style="height: 130px; margin: 0px;" class="row">
                            <!-- <div class="form-check col-1" style="display: inline-block; vertical-align: top; margin-top: 30px;">
                                <input [id]="productPerOrg.uuid" class="form-check-input" type="checkbox" value="" [checked]="this.cartLines[productPerOrg.uuid].selected" (change)="this.productToggle($event, productPerOrg.uuid)">
                            </div> -->
                            <label style="width: 100px; height: 110px; padding: 3px; border: 1px solid #EDF5FC; border-radius: 10px; margin-top: 10px; vertical-align: unset;" [for]="productPerOrg.uuid">
                                <img style="width: 90px; height: 100px; vertical-align: unset;"   [src]="productPerOrg.imageSource" alt="">
                            </label>
                            <div class="col-7 product"  style="display: inline-block;  margin-top: 10px; " >
                                <p (click)="this.goToProduct(productPerOrg)" style="font-size: 13px; font-weight: bold; margin-bottom: 5px; display: -webkit-box;-webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; height: 40px; overflow: hidden; text-overflow: ellipsis; text-align: left; margin-top: 5px; text-overflow: ellipsis;">{{ productPerOrg.sku.product.name }}</p>
                                <p  *ngIf="productPerOrg.sku?.options?.length" style="font-size: 10px; color: #ADAFBB;"><span *ngFor="let option of productPerOrg.sku?.options || []; index as i"> {{ option.option?.display_name + ': ' + this.returnOptionValue(option) + ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '')}}</span></p>
                                <p *ngIf="!productPerOrg.sku.options.length" style="font-size: 10px; color: #ADAFBB;">&nbsp;</p>
                                <p *ngIf="!this.isProductAvailable(productPerOrg)" style="font-size: 14px; font-weight: bold; width: fit-content; display: inline-block; "><span style="font-size: 12px; color: #BD362F;">Изчерпан</span></p>
                                <div *ngIf="this.isProductAvailable(productPerOrg)" style="min-width: 170px;">
                                  <div class="preorder-item-row">
                                    <div class="preorder-item-info">
                                      <app-price
                                        class="preorder-line-total-price"
                                        [amount]="getLineTotalBase(productPerOrg)"
                                        layout="inline"
                                      ></app-price>

                                      <div class="preorder-item-subprice">
                                        <span class="preorder-line-mult">{{ pricingInfoText(productPerOrg) }}</span>
                                        <app-price
                                          class="preorder-line-unit-price"
                                          [amount]="getUnitPriceBase(productPerOrg)"
                                          layout="inline"
                                        ></app-price>
                                      </div>
                                    </div>

                                    <div class="preorder-item-qty">
                                      <span>Брой: {{ productPerOrg.quantity }}</span>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 15px; margin-bottom: 10px;">

                    </div>
                    <div class="row" style="margin-top: 12px;">
                      <p class="col-6" style="text-align: left; position: relative; top: 5px;">Доставка:</p>
                      <div class="col-6" style="text-align: right; position: relative; top: 5px;">
                        <ng-container *ngIf="getOrgDeliveryBase(orgs) > 0; else freeOrgDeliveryTpl">
                          <app-price
                            [amount]="getOrgDeliveryBase(orgs)"
                            layout="inline"
                          ></app-price>
                        </ng-container>
                        <ng-template #freeOrgDeliveryTpl>Безплатна</ng-template>
                      </div>
                    </div>

                    <div class="row" style="margin-top: 12px;">
                      <p class="col-6" style="text-align: left; position: relative; top: 5px; font-weight: bold;">
                        {{ "Общо за " + this.cartLinePerOrganisation[orgs][0]?.sku?.product?.organisation?.native_name + ":" }}
                      </p>
                      <div class="col-6" style="text-align: right; position: relative; top: 5px; font-weight: bold;">
                        <app-price
                          [amount]="getOrgGrandTotalBase(orgs)"
                          layout="inline"
                        ></app-price>
                      </div>
                    </div>
                </div>
            </div>


        <div *ngIf="!this.isGroup" style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px; padding-top: 20px;">
            <div (click)="this.open(vouchers)">
                <p style="display: inline-block;">Избери ваучер</p>
                <img *ngIf="!this.selectedVoucher" style="float: right;width: 10px; height: 10px; margin: 5px;" src="/assets/images/shared/down-tap.svg">
            </div>
            <div *ngIf="this.selectedVoucher">
                <img style="width: 44px; height: 44px; margin: 5px; position: relative; top: -10px;" src="/assets/images/vouchers/voucher.svg" alt="">
                <p style="font-weight: bold; display: inline-block; width: 50%; margin: 5px;">
                    {{ this.fixVoucherSum(this.selectedVoucher!.amount) }}
                    <br>
                    <span style="color: #ADAFBB; font-size: 11px;">
                         {{ this.fixVoucherDate(this.selectedVoucher!.created_at) }}
                    </span>
                </p>
                <img (click)="this.clearVoucher()" style="float: right;width: 20px; height: 20px; margin: 5px; position: relative; top: 10px;" src="/assets/images/orders/remove.svg">

            </div>
        </div>


        <div *ngIf="this.isGroup && this.groupCartLine" style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
          <div class="row">
            <div class="col-6" style="text-align: left;">Междинна сума:</div>
            <div *ngIf="!this.groupDelivery" class="col-6" style="color: #6FAE2E; text-align: right; margin-top: 5px;">Безплатна</div>
            <div class="col-6" style="text-align: right;">
              <app-price
                [amount]="getGroupSubtotalBase()"
                layout="inline"
              ></app-price>
            </div>

            <br>

            <div class="col-6" style="text-align: left; margin-top: 5px;">Доставка:</div>
            <div *ngIf="this.groupDelivery" class="col-6" style="color: #6FAE2E; text-align: right; margin-top: 5px;">
              <app-price
                [amount]="getGroupDeliveryBase()"
                layout="inline"
              ></app-price>
            </div>

            <div class="col-6" style="text-align: left;">Ваучер:</div>
            <div *ngIf="this.selectedVoucher" class="col-6" style="text-align: right; color: red;">
              -
              <app-price
                [amount]="getSelectedVoucherBase()"
                layout="inline"
              ></app-price>
            </div>
            <div *ngIf="!this.selectedVoucher" class="col-6" style="text-align: right;">-</div>
          </div>

          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

          <div class="row">
            <div class="col-6" style="font-weight: bold; text-align: left;">Общо:</div>
            <div class="col-6" style="font-weight: bold; text-align: right;">
              <app-price
                [amount]="getGroupGrandTotalBase()"
                layout="inline"
              ></app-price>
            </div>
          </div>
        </div>

        <div *ngIf="!this.isGroup || !this.groupCartLine" style="width: 95%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
          <div class="row">
            <div class="col-6" style="text-align: left;">Междинна сума:</div>
            <div class="col-6" style="text-align: right;">
              <app-price
                [amount]="getProductsSubtotalBase()"
                layout="inline"
              ></app-price>
            </div>

            <br>

            <div class="col-6" style="text-align: left; margin-top: 5px;">Доставка:</div>
            <div *ngIf="!this.deliveryAmount" class="col-6" style="color: #6FAE2E; text-align: right; margin-top: 5px;">Безплатна</div>
            <div *ngIf="this.deliveryAmount" class="col-6" style="color: #6FAE2E; text-align: right; margin-top: 5px;">
              <app-price
                [amount]="getDeliveryAmountBase()"
                layout="inline"
              ></app-price>
            </div>

            <div class="col-6" style="text-align: left;">Ваучер:</div>
            <div *ngIf="this.selectedVoucher" class="col-6" style="text-align: right; color: red;">
              -
              <app-price
                [amount]="getSelectedVoucherBase()"
                layout="inline"
              ></app-price>
            </div>
            <div *ngIf="!this.selectedVoucher" class="col-6" style="text-align: right;">-</div>
          </div>

          <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 10px;">

          <div class="row">
            <div class="col-6" style="font-weight: bold; text-align: left;">Общо:</div>
            <div class="col-6" style="font-weight: bold; text-align: right;">
              <app-price
                [amount]="getWholeSumBase()"
                layout="inline"
              ></app-price>
            </div>
          </div>
        </div>
    </div>
    <div style="position: fixed; bottom: 35px; text-align: center; width: 90%; margin: auto; left: 5%;">
        <div *ngIf="paymentErrorMessage" class="alert alert-danger" style="font-size: 12px; padding: 8px; margin-bottom: 8px; text-align: left;">
            {{ paymentErrorMessage }}
        </div>
        <button [disabled]="this.payBtnDisabled" type="button" class="btn btn-primary" style="width: 100%; margin: auto; height: 45px;" (click)="this.pay()">{{ this.isGroup ? this.groupBtn : "Поръчай" }}</button>
    </div>
</div>

<ng-template #vouchers let-modal>
    <div style="padding: 10px !important;">
        <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">Моите ваучери</h3>
        <!-- <div *ngFor="let voucher of this.vouchers"> -->
        <div>
            <div *ngIf="!this.userVouchers.data.length">
                <p style="text-align: center; color: #ADAFBB; ">
                    Нямате ваучери.
                </p>
            </div>
            <div *ngFor="let voucher of this.userVouchers.data" (click)="this.chooseVoucher(voucher, modal)">
                <img style="width: 44px; height: 44px; margin: 5px; position: relative; top: -10px;" src="/assets/images/vouchers/voucher.svg" alt="">
                <p style="font-weight: bold; display: inline-block; width: 50%; margin: 5px;">
                  <app-price
                    class="voucher-modal__amount"
                    [amount]="getVoucherAmountBase(voucher)"
                    layout="inline"
                  ></app-price>
                    <br>
                    <span style="color: #ADAFBB; font-size: 11px;">
                         {{ this.fixVoucherDate(voucher.created_at) }}
                    </span>
                </p>
            </div>
            <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        </div>
    </div>
</ng-template>
